<template>
  <div ref="withdraw">
    <!-- top -->
    <van-sticky>
      <van-nav-bar title="查卡" left-arrow @click-left="onClickLeft">
      </van-nav-bar>
    </van-sticky>
    <!-- top -->

    <van-dialog
      :before-close="delBankBefore"
      v-model="delBankModal"
      title="删除"
      show-cancel-button
    >
      <p style="text-align: center; color: red; padding: 15px">确认删除</p>
      <p
        style="
          text-align: center;
          padding: 15px;
          padding-top: 0px;
          word-break: break-all;
        "
      >
        {{ currentData.bank_no }} - {{ currentData.bank_name }}
      </p>
    </van-dialog>
    <van-datetime-picker
      v-model="firstDate"
      type="date"
      title="选择年月日"
      v-if="showF"
      @cancel="cancelFTome(firstDate)"
      @confirm="setFTome"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <van-datetime-picker
      v-model="endDate"
      type="date"
      title="选择年月日"
      v-if="showS"
      @cancel="cancelSTome(endDate)"
      @confirm="setSTome"
      :min-date="minDate"
      :max-date="maxDate"
    />

    <div
      class="wrap"
      :style="{
        backgroundImage:
          'url(' +
          $returnColor().path +
          ($store.state.selfData.member_id
            ? '/home-page_bg.png'
            : '/home-page_bg.png') +
          ')',
      }"
    >
      <div class="contentWrap">
        <van-form>
          <van-field
            readonly
            clickable
            name="类型"
            :value="year.text"
            label="类型"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="dateOption"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
          <van-field
            v-model="searchValue"
            type="text"
            :name="year.text"
            :label="year.text"
            :placeholder="year.text"
          />
          <div style="margin: 16px">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              @click="search"
            >
              搜寻
            </van-button>
          </div>
        </van-form>

        <div class="tableWrap" v-for="(list, key) in depositList" :key="key">
          <p class="tableContent">
            <span class="tableTitle"> 银行卡号 </span>
            <span class="tablesContent">
              {{ list.bank_no }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 开户银行 </span>
            <span class="tablesContent">
              {{ list.bank_name }}
            </span>
          </p>
          <p
            class="tableContent"
            v-if="
              list.bank_name != '抖音红包' && list.bank_name != '数字人民币'
            "
          >
            <span class="tableTitle">
              {{
                list.bank_name != "支付宝" && list.bank_name != "微信"
                  ? "支行名称"
                  : "真实姓名"
              }}
            </span>
            <span class="tablesContent">
              {{ list.bank_branch }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle">
              {{
                list.bank_name != "支付宝" && list.bank_name != "微信"
                  ? "姓名"
                  : "昵称"
              }}
            </span>
            <span class="tablesContent">
              {{ list.bank_owner }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 异常 </span>
            <span class="tablesContent">
              {{ list.aberrant == 0 ? "正常" : "异常" }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 每日限额 </span>
            <span class="tablesContent">
              {{ list.ds_limit || "未设置" }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 今日收款 </span>
            <span class="tablesContent">
              {{ list.trans_amount }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 启用状态 </span>
            <span class="tablesContent">
              <span v-if="list.enable != 2">{{
                list.enable == 1 ? "启用" : "未启用"
              }}</span>
              <span v-else style="color: red">待审核</span>
            </span>
          </p>

          <p class="tableContent">
            <span class="tableTitle"> 收款卡 </span>
            <span class="tablesContent">
              {{ list.is_collection == 1 ? "是" : "否" }}
            </span>
          </p>
          <p class="tableContent">
            <span class="tableTitle"> 出款卡 </span>
            <span class="tablesContent">
              {{ list.is_pay == 1 ? "是" : "否" }}
            </span>
          </p>
          <p
            class="tableContent"
            v-if="
              ($store.state.selfData.m_id == 60007 ||
                $store.state.selfData.m_id == 60002) &&
              list.bank_name == '支付宝'
            "
          >
            <span class="tableTitle"> 绑定 </span>
            <span class="tablesContent">
              {{ list.alipay_userid ? "已绑定" : "未绑定" }}
            </span>
          </p>
          <div class="editBtn" style="width: 100%">
            <p
              style="color: red; width: 100%; text-align: center"
              @click="delBank(list)"
            >
              删除
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
  data() {
    return {
      minDate: new Date(2021, 0, 1),
      maxDate: new Date(),
      type: false,
      open: false,
      currentGropId: "",
      year: { text: "用户号", value: "id" },
      month:
        String(new Date().getMonth() + 1).length == 1
          ? "0" + String(new Date().getMonth() + 1)
          : String(new Date().getMonth() + 1),
      dateOption: [
        { text: "用户号", value: "id" },
        { text: "帐号", value: "username" },
        { text: "姓名", value: "name" },
        { text: "卡号", value: "bank_no" },
      ],
      monthOption: [
        { text: "01", value: "01" },
        { text: "02", value: "02" },
        { text: "03", value: "03" },
        { text: "04", value: "04" },
        { text: "05", value: "05" },
        { text: "06", value: "06" },
        { text: "07", value: "07" },
        { text: "08", value: "08" },
        { text: "09", value: "09" },
        { text: "10", value: "10" },
        { text: "11", value: "11" },
        { text: "12", value: "12" },
      ],
      depositPaginate: {},
      depositList: [],

      depositPage: 1,
      withdrawList: [],
      withdrawPaginate: {},
      withdrawPage: 1,
      isLoading: false,
      value: "",
      showPicker: false,
      dates: { startDate: "" },
      firstDate: "",
      endDate: "",
      showF: false,
      showS: false,
      inFilter: false,
      saveData: false,
      showFast: true,
      next_page: true,
      current_page: 1,
      selectOrdder: [],
      searchOrderId: "",
      pay_bank_no: "",
      searchValue: "",
      currentData: {},
      delBankModal: false,
    };
  },
  methods: {
    delBankBefore(method, done) {
      if (method == "confirm") {
        this.$http
          .delete(`/mobile/advanced/cards/${this.currentData.id}`)
          .then((res) => {
            if (res.data.code == 0) {
              this.search();
              this.delBankModal = false;
              Toast.success("成功");
            }
          });
      } else {
        done();
      }
      done();
    },
    delBank(list) {
      this.currentData = JSON.parse(JSON.stringify(list));
      this.delBankModal = true;
    },
    search() {
      if (!this.searchValue) {
        this.$toast.error("请输入搜寻");
        return;
      }
      this.$http
        .get(`/mobile/advanced/cards`, {
          params: {
            search_type: this.year.value,
            search: this.searchValue,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.depositList = res.data.data;
          }
        });
    },
    sendShop() {
      let snedData = this.selectOrdder.map((e) => {
        return e.order_id;
      });
      this.$dialog.confirm({
        title: "传送商城",
        message: `确认传送商城 ${snedData.length}笔`,

        beforeClose(method, done) {
          if (method == "confirm") {
            this.$http
              .post(`/mobile/paymentSubmit`, { ids: snedData })
              .then((res) => {
                if (res.data.code == 0) {
                  this.$toast.success("成功");
                  this.selectOrdder = [];
                }
              });
          }
          done();
        },
      });
    },
    handleSelectionChange(val) {
      this.selectOrdder = val;
    },
    clearSelect() {
      this.type = false;
      this.firstDate = "";
      this.endDate = "";
      this.searchOrderId = "";
      this.pay_bank_no = "";
    },
    onCopy() {
      this.$toast.success("已复制");
    },
    setFTome(d) {
      this.firstDate = this.$returnTime(d);
      this.showF = false;
    },
    setSTome(d) {
      this.endDate = this.$returnTime(d);
      this.showS = false;
    },
    cancelSTome() {
      this.showS = false;
      return;
    },
    cancelFTome() {
      this.showF = false;
      return;
    },
    onConfirm(value) {
      this.year = value;
      this.showPicker = false;
    },
    onClickLeft() {
      this.$router.push(`/`);
    },
  },
  created() {
    // this.getDeposit();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollPage);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollPage);
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  // background-image: url("/home-page_bg.png");
  // background-position: center center;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contentWrap {
  max-width: 350px;
  width: 100%;
}
.dropdown {
  margin-bottom: 15px;
  position: relative;
  .arrow {
    position: absolute;
    right: 10px;
    top: 35%;
  }
  .van-dropdown-menu__title {
    margin-right: auto !important;
  }
  .van-dropdown-menu__bar {
    border-radius: 10px !important;
  }
}

.contentWrap {
  // background-attachment: fixed;
}
.dateWrap {
  display: flex;
  margin-bottom: 10px;
}
.logWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  height: 60px;
  flex-wrap: wrap;
  transition: 0.3s ease-in-out;
  .orderId {
    height: 0;
    overflow: hidden;
  }
  .left {
    width: 60%;
    .title {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    .date {
      font-size: 12px;
      color: #999999;
    }
  }
  .right {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .balance {
      color: #009aaa;
      font-size: 14px;
      font-weight: 500;
      margin-right: 5px;
    }
    i {
      color: #999999;
      font-weight: bold;
      font-size: 16px;
      transition: 0.3s ease-in-out;
    }
  }
}
.logWrap.active {
  height: 120px;
  .orderId {
    height: auto;
    width: 100%;
    font-size: 12px;
    padding-right: 20px;
    display: flex;
    position: relative;
    .copyIcon {
      position: absolute;
      right: 0px;
      font-size: 14px;
    }
    .title {
      color: #999999;
      white-space: nowrap;
    }
    .id {
      margin-left: 5px;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .right {
    i {
      transform: rotate(180deg);
    }
  }
}
.rightSelect {
  display: flex;
  align-items: center;
  color: #009aaa;
  .icon {
    // color: #009aaa !important;
  }
}
.leftSelect {
  position: fixed;
  top: 46px;
  bottom: 0px;
  right: 0px;
  left: 0;
  background-color: rgba(black, 0.8);
  z-index: 999;
  overflow: scroll;
  .selectContent {
    width: 80%;
    background-color: #fff;
    position: fixed;
    right: 0;
    top: 46px;
    bottom: 0;
  }
}
.drawerTime {
  border: 0.5px solid #cccccc;
  color: #cccccc;
}
.drawerWrap {
  color: #333333 !important;
  .content {
    .title {
      font-size: 16px;
      font-weight: 500;
      background-color: rgb(242, 242, 242);
      line-height: 50px;
      padding-left: 10px;
    }
  }
  .drawerContentWrap {
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    label {
      color: #333333;
      margin-top: 5px;
      line-height: 30px;
    }
    .drawerTime {
      width: 115px;
      // height: 24px;
    }
    .pickerWrap {
      display: flex;
      align-items: center;
      .datePick {
        width: 115px;
        height: 30px;
        align-items: center;
        line-height: 30px;
        border: 0.5px solid #cccccc;
        text-align: center;
        color: #cccccc;
      }
    }
  }
  .footBtnWrap {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    button {
      width: 80px;
      height: 24px;
      margin-left: 5px;
      margin-right: 5px;
    }
    .reset {
      border: 0.5px solid #009aaa;
      color: #009aaa;
    }
    .use {
      background-color: #009aaa;
      color: white;
    }
  }
}
</style>
<style lang="scss">
.tableee {
  .el-table .el-table__cell {
    padding: 0 !important;
  }

  // .el-table__header-wrapper .el-checkbox__input::after {
  //   content: "全选";
  //   position: absolute;
  //   font-size: 12px;
  //   margin-left: 5px;
  //   left: -10px;
  //   z-index: 999;
  //   top: -14px;
  //   color: white;
  // }
  // .el-table--border .el-table__cell:first-child .cell {
  //   padding: 15px 0;
  // }
}

.tableWrap {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  width: 355px;
  padding: 10px 20px;
  padding-bottom: 0px;
  border-radius: 10px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  .tableContent {
    width: 100%;
    display: flex;
    font-size: 14px;
    height: 25px;
    align-items: center;
    .tableTitle {
      font-weight: 400;
      white-space: nowrap;
      width: 60px;
      text-align: left;
      margin-right: 10px;
    }
    .tablesContent {
      color: #999999;
      word-break: break-all;
    }
  }
}
</style>
